import CustomComponent from '../CustomComponent';
import { getCookie, setCookie, addCookieChangeListener, startOptimizedCookiePolling } from '../../utils/cookies';
import { isMobileDevice, getAppStoreLink } from '../../utils/deviceDetection';

class AppDownloadBanner extends CustomComponent {
    static key = 'lta-app-download-banner';

    static get observedAttributes() {
        return ['show', 'title', 'subtitle', 'ios-app-id', 'android-package-name', 'expires-in-days'];
    }

	constructor() {
		super();
		this.cookieName = 'app-download-banner-dismissed';
		this.state = {
			show: !getCookie(this.cookieName) && isMobileDevice()
		};
		this.removeCookieListener = null;
		this.stopPolling = null;
	}

    onLoad() {
        this.startCookiePolling();
        this.setupCookieChangeListener();
    }

    onUnload() {
        this.stopCookiePolling();
        this.removeCookieChangeListener();
    }

    setupCookieChangeListener() {
        this.removeCookieListener = addCookieChangeListener(this.cookieName, (value) => {
            const shouldShow = !value && isMobileDevice();
            if (this.state.show !== shouldShow) {
                this.setState({ show: shouldShow });
            }
        });
    }

    removeCookieChangeListener() {
        if (this.removeCookieListener) {
            this.removeCookieListener();
            this.removeCookieListener = null;
        }
    }

    startCookiePolling() {
        // Use optimized polling that doesn't block UI
        this.stopPolling = startOptimizedCookiePolling(this.cookieName, (value) => {
            const shouldShow = !value && isMobileDevice();
            if (this.state.show !== shouldShow) {
                this.setState({ show: shouldShow });
            }
        }, 3000); // Poll every 3 seconds instead of 1 second
    }

    stopCookiePolling() {
        if (this.stopPolling) {
            this.stopPolling();
            this.stopPolling = null;
        }
    }

    afterRender() {
        const closeButton = this.querySelector('.lta-app-download-banner__close');
        if (closeButton && !closeButton.hasAttribute('data-listener-bound')) {
            closeButton.setAttribute('data-listener-bound', 'true');
            closeButton.addEventListener('click', this.hide.bind(this));
        }
    }

	hide() {
		this.setState({ show: false });
		setCookie(this.cookieName, 'true', this.props.expiresInDays);
	}

	render() {
        const { show } = this.state;

        if (!show) {
            return '';
        }

        // Replace these with your actual app store IDs
        const iosAppId = this.props.iosAppId;
        const androidPackageName = this.props.androidPackageName;
        const appStoreLink = getAppStoreLink(iosAppId, androidPackageName);
        const title = this.props.title;
        const subtitle = this.props.subtitle;

        return `
			<div class="lta-app-download-banner">
                <div class="lta-app-download-banner__container">
                    <div class="lta-app-download-banner__close" tabindex="0" role="button" aria-label="Close">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="18.0105" y="15.8892" width="3" height="14" transform="rotate(135 18.0105 15.8892)" fill="black"/>
                            <rect x="15.8892" y="5.98975" width="3" height="14" transform="rotate(45 15.8892 5.98975)" fill="black"/>
                        </svg>
                    </div>
                    <div class="lta-app-download-banner__image-container">
                        <img
                            class="lta-app-download-banner__icon"
                            src="/static/images/logos/app-icon.svg"
                            alt="Our Play app icon"
                            aria-label="Our Play app icon"
                            tabindex="0"
                        />                        
                    </div>
                    <div class="lta-app-download-banner__content">
                        <h2 class="lta-app-download-banner__title" tabindex="0" role="button" aria-label="Download our app">${title}</h2>
                        <p class="lta-app-download-banner__subtitle" tabindex="0" role="button" aria-label="Download our app">${subtitle}</p>
                    </div>
                    <div class="lta-app-download-banner__open">
                        <lta-button label="Open" tag="a" href="${appStoreLink}"></lta-button>
                    </div>
                </div>
            </div>
		`;
	}
}

export default AppDownloadBanner;